import axios from "axios";
import {options} from "@/commom/initial";

axios.defaults.baseURL = window._url;

// http request 拦截器
axios.interceptors.request.use(
    config => {
        if(!exclude.includes(config.url)) config.url += options.url_suffix[options.language || 'zh'];
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// 多语言请求
let exclude = ['/medata/selectVersion'];

export let api = {
    selectIntroduce() {
        return axios.get("/introduction/select");
    }
}

// 数据集
export let datasetApi = {
    selectAll() {
        return axios.get("/dataset/select2");
    },
    selectById(id) {
        return axios.get("/dataset/selectById", {
            params: {
                id: id
            }
        });
    }
}

// 元数据
export let medataApi = {
    selectByDatasetid(datasetid) {
        return axios.get("/medata/selectByDatasetid", {
            params: {
                datasetid: datasetid
            }
        })
    },
    selectVersion(id) {
        return axios.get("/medata/selectVersion", {
            params: {
                mdid: id
            }
        })
    }
}